// OrderItem.jsx
import React, { useState } from "react";
import "./Orders.css";
import { setIsPaid, setCancelPaid, deleteOrder } from "./orderApi"; // убедись, что пути и имена совпадают
import BlinkingDate from "./BlinkingDate";
import SelectableCircle from "./SelectableCircle";

const OrderItem = ({ order, handleOrderClick, refreshOrders, selectForAct, selectedOrders, onSelectOrder }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showDelModal, setShowDelModal] = useState(false);

  const toggleMenu = (e) => {
    e.stopPropagation();
    setIsMenuOpen((v) => !v);
  };

  const handleArchive = (e) => {
    e.stopPropagation();
    setIsMenuOpen(false);
    // Если требуется — реализуй API архивирования и вызови refreshOrders()
    console.log("В архив (TODO):", order.id);
  };

  const handleSetIsPaid = (e) => {
    e.stopPropagation();
    setIsMenuOpen(false);

    if (order.price === order.paid) {
      setCancelPaid({ order_id: order.id }, (data) => {
        refreshOrders();
      });
    } else {
      setIsPaid({ order_id: order.id, paid: order.price, prepaid: order.paid }, (data) => {
        refreshOrders();
      });
    }
  };

  const handleDeleteConfirm = (e) => {
    e.stopPropagation();
    setShowDelModal(true);
    setIsMenuOpen(false);
  };

  const handleDelOrder = () => {
    deleteOrder({ order_id: order.id }, (data) => {
      // обновляем список
      if (typeof refreshOrders === "function") refreshOrders();
      setShowDelModal(false);
    });
  };

  return (
    <>
      <div className="order-card" onClick={() => handleOrderClick(order)}>
        {selectForAct && (
          <SelectableCircle
            selected={selectedOrders.includes(order.id)}
            onPress={() => onSelectOrder(order.id)}
          />
        )}
        <div className="subcntr_order order-part-1">
          {/* троеточие — абсолютное, не ломает layout */}
          <div className="order-item-dots" onClick={(e) => e.stopPropagation()}>
            <div className="dots" onClick={toggleMenu}>
              ⋮
            </div>
            {isMenuOpen && (
              <div className="order-menu-dropdown" onClick={(e) => e.stopPropagation()}>
                <div className="menu-item" onClick={handleSetIsPaid}>
                  {order.price - order.paid > 0 ? "Оплачен" : "Отмена"}
                </div>
                <div className="menu-item" onClick={handleDeleteConfirm}>
                  Удалить
                </div>
                <div className="menu-item" onClick={handleArchive}>
                  В архив
                </div>
              </div>
            )}
          </div>

          <div className="">
            <div className="order-header">
              <span className="order-number">№ {order.number || order.id}</span>

              <span
                className="order-debt"
                style={{
                  color:
                    order.price - order.paid > 0 || order.price === 0 ? "red" : "green",
                }}
              >
                {order.price - order.paid > 0 || order.price === 0
                  ? `${order.price - order.paid} ₽`
                  : "Оплачен"}
              </span>

              <div className="order-date">
                {order.date ? new Date(order.date).toLocaleDateString("ru-RU") : ""}
              </div>
            </div>

            <div className="order-body">
              <div className="order-body-left">
                <div className="order-field">
                  Пациент: <b>{order.pacient}</b>
                </div>
                <div className="order-field">
                  {'Дата сдачи: '}
                  <BlinkingDate date={order.date_delivery} is_active={order.is_active} />
                </div>

              </div>
              <div className="order-body-right">
                <div className="order-field">
                  Цвет: {order.color}
                </div>
                <div className="order-field">
                  Стоимость: {order.price} ₽
                </div>
              </div>
            </div>
          </div>

          {order.url_photo && (
            <img
              src={`${process.env.REACT_APP_API_URL}static/uploads/${order.url_photo}`}
              alt="Фото заказа"
              className="order-photo"
            />
          )}
        </div>
      </div>

      {/* Модал подтверждения удаления */}
      {showDelModal && (
        <div className="modal-overlay" onClick={() => setShowDelModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h4>Удалить заказ?</h4>
            <p>Номер: {order.number || order.id}</p>
            <div style={{ display: "flex", gap: 12, marginTop: 12 }}>
              <button className="modal-btn" onClick={() => setShowDelModal(false)}>
                Нет
              </button>
              <button className="modal-btn" onClick={handleDelOrder}>
                Да
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default OrderItem;
